import React from "react";

import "./Skills.scss";
import JS from "../../assets/Icons/Logo/js.svg";
import Html from "../../assets/Icons/Logo/html.svg";
import Reacticon from "../../assets/Icons/Logo/react.svg";
import Sass from "../../assets/Icons/Logo/sass.svg";
import Node from "../../assets/Icons/Logo/node.svg";
import Github from "../../assets/Icons/Logo/github.svg";
import Wordpress from "../../assets/Icons/Logo/wordpress.png";
import Shopify from "../../assets/Icons/Logo/shopify.png";
import Liquid from "../../assets/Icons/Logo/liquid.png";

const skillGroups = [
  {
    title: "Front-End",
    items: [
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "responsive layouts",
      "accessibility",
      "animation",
      "component-based UI",
    ],
  },
  {
    title: "E-commerce",
    items: [
      "Salesforce Commerce Cloud",
      "Shopify",
      "Liquid",
      "Page Designer",
      "content assets",
      "product/category landing pages",
    ],
  },
  {
    title: "Experimentation & Marketing Tech",
    items: [
      "Bloomreach",
      "A/B testing",
      "web layers",
      "personalization",
      "GTM coordination",
      "campaign QA",
    ],
  },
  {
    title: "Backend & Tools",
    items: [
      "Node",
      "Express",
      "PHP",
      "SQL",
      "GitHub",
      "API integration",
      "WordPress",
    ],
  },
];

const iconSkills = [
  { icon: JS, label: "JavaScript" },
  { icon: Html, label: "HTML" },
  { icon: Reacticon, label: "React" },
  { icon: Sass, label: "Sass" },
  { icon: Shopify, label: "Shopify" },
  { icon: Liquid, label: "Liquid" },
  { icon: Wordpress, label: "WordPress" },
  { icon: Node, label: "Node" },
  { icon: Github, label: "GitHub" },
];

function Skills() {
  return (
    <section className="skills" id="skills">
      <div className="skills__inner">
        <h2 className="contact-nameheaderdesktop reveal">Skills</h2>
        <p className="skills__intro reveal">
          Practical front-end and e-commerce tools for building campaigns,
          storefronts, product content and measurable web experiences.
        </p>

        <div className="skills-groups">
          {skillGroups.map((group, index) => (
            <article
              className="skills-group reveal"
              key={group.title}
              style={{ "--reveal-delay": `${(index % 2) * 90}ms` }}
            >
              <h3>{group.title}</h3>
              <p>{group.items.join(", ")}</p>
            </article>
          ))}
        </div>

        <div className="skills-grid" aria-label="Core tools">
          {iconSkills.map((skill, index) => (
            <div
              className="skills-box reveal"
              key={skill.label}
              style={{ "--reveal-delay": `${(index % 5) * 45}ms` }}
              data-tooltip={skill.label}
            >
              <img className="skills-icon" src={skill.icon} alt="" />
              <p className="skills-text">{skill.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
